import { render } from "./RecruiterDashboard.vue?vue&type=template&id=800e18fe"
import script from "./RecruiterDashboard.vue?vue&type=script&lang=js"
export * from "./RecruiterDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script